<template>
    <transition name="skip-intro">
        <button class="skip-intro" :class="{ highlight }" type="button" v-if="show" @click.stop="skip">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
                <polygon points="5 4 15 12 5 20 5 4" fill="currentColor" />
                <line x1="19" y1="5" x2="19" y2="19" />
            </svg>
            Skip Intro
        </button>
    </transition>
</template>

<script>
export default {
    name: 'SkipIntro',
    props: {
        show: { type: Boolean, default: false },
        highlight: { type: Boolean, default: false },
        skip: { type: Function, required: true }
    }
}
</script>

<style lang="scss" scoped>
.skip-intro {
    position: absolute;
    right: 40px;
    bottom: 105px;
    z-index: 4;
    display: inline-flex;
    align-items: center;
    gap: 12px;
    padding: 12px 15px;
    font-size: 12px;
    color: #fff;
    background: rgba(20, 20, 20, 0.1);
    border: 0px solid rgba(255, 255, 255, 0.55);
    border-radius: 6px;
    backdrop-filter: blur(6px);
    overflow: hidden;
    cursor: pointer;
    transition: background-color 0.15s ease, border-color 0.15s ease, transform 0.15s ease, box-shadow 0.15s ease;

    svg {
        width: 12px;
        height: 12px;
    }

    &.highlight {
        background: rgba(20, 20, 20, 0.55);
        border-color: rgba(255, 255, 255, 0.35);
        box-shadow: 0 4px 18px rgba(0, 0, 0, 0.35);

        &::after {
            content: '';
            position: absolute;
            top: 0;
            bottom: 0;
            left: 0;
            width: 60%;
            background: linear-gradient(105deg, transparent 0%, rgba(255, 255, 255, 0.55) 50%, transparent 100%);
            transform: translateX(-160%) skewX(-12deg);
            animation: skip-intro-sweep 1.4s ease-in-out 1;
            pointer-events: none;
        }
    }

    &:hover {
        background: rgba(255, 255, 255, 0.92);
        border-color: #fff;
        color: #000;
        transform: scale(1.04);
    }

    &:focus-visible {
        outline: 2px solid #fff;
        outline-offset: 3px;
    }
}

@keyframes skip-intro-sweep {
    0% {
        transform: translateX(-160%) skewX(-12deg);
    }
    100% {
        transform: translateX(260%) skewX(-12deg);
    }
}

@media (prefers-reduced-motion: reduce) {
    .skip-intro.highlight::after {
        animation: none;
        opacity: 0;
    }
}

.skip-intro-enter-active,
.skip-intro-leave-active {
    transition: opacity 0.2s ease, transform 0.2s ease;
}

.skip-intro-enter,
.skip-intro-enter-from,
.skip-intro-leave-to {
    opacity: 0;
    transform: translateX(12px);
}
</style>
